import React, { useContext, useEffect, useState } from 'react'
import GlobalContext from '../../../../contexts/globalContext';
import { ReferenciaContenido } from '../../../../interfaces/ReferenciaContenido';
import { getDiagnosticQuestions, getResults, getToken, postResponsesDiagnostic } from '../../../../services/mentoriaService';
import Button from '../../../atoms/button/button'
import Loading from '../../../atoms/loading/loading';
import Stepper from '../../../atoms/stepper/stepper';
import SubsectionContainer from '../../../molecules/subsection-container/subsectionContainer';
import MentoriaAgendamientoCitas from '../mentoria-agendamiento-citas/mentoriaAgendamientoCitas';
import MentoriaLoading from '../mentoria-loading/mentoriaLoading';
import MentoriaOtp from '../mentoria-otp/mentoriaOtp';
import MentoriaQuestionWizard from '../mentoria-question-wizard/mentoriaQuestionWizard';
import MentoriaResultados from '../mentoria-resultados/mentoriaResultados';
import TratamientoDatos from '../tratamiento-datos/tratamientoDatos';
import './mentoriaDiagnostico.scss'

interface MentoriaDiagnosticoProps {
    estadoFinanzasData: ReferenciaContenido;
    blobImage: string;
    headerImages: Array<string>;
    facesIcons: Array<string>;
    tooltipImage: string;
    agendamientoIcons: Array<string>;
    otpIcons: Array<string>;
    rutaPhotos: Array<string>
}

const MentoriaDiagnostico = (props: MentoriaDiagnosticoProps) => {
    const [showQuestions, setShowQuestions] = useState<boolean>(false);
    const [showResults, setShowResults] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);
    const [diagnosticQuestions, setDiagnosticQuestions] = useState<any>(null);
    const [continueRoute, setContinueRoute] = useState(false);
    const [cac, setCac] = useState(false);
    const [diagnosticData, setDiagnosticData] = useState<any>({});
    const [diagnosticDataV2, setDiagnosticDataV2] = useState<any>([]);
    const [headers, setHeaders] = useState<any>([]);
    const [acceptTratamiento, setAcceptTratamiento] = useState(false);
    const Context = useContext(GlobalContext);
    const [result, setResult] = useState({});
    const [step, setStep] = useState(0);

    useEffect(() => {
        if (!Context.gigyaContext.gigyaAccount) {
            const timer = setTimeout(() => {
                if (!Context.gigyaContext.gigyaAccount) {
                    Context.gigyaContext.login();
                }
            }, 1500);

            return () => clearTimeout(timer);
        } else {
            const {
                email,
                age,
                firstName,
                lastName,
                city,
                gender,
            } = Context.gigyaContext.gigyaAccount.profile;
            const {
                docNumber,
                docType,
                mobile,
                phone,
            } = Context.gigyaContext.gigyaAccount.data;


            const docTypes = {
                C: "Cédula de ciudadanía",
                T: "Tarjeta de identidad",
                E: "Cédula de extranjería",
                P: "Pasaporte",
                R: "Registro Civil",
                V: "Permiso especial de permanencia",
            };

            const genders = {
                u: "Prefiero no decirlo",
                f: "Femenino",
                m: "Masculino",
            };

            /*
               Cedula -> C
               Cedula de extranjeria -> E
               pasaporte -> P
               registro civil -> R
               Tarjeta de identidad -> T
               permiso especial de permanencia -> V
   
               */

            setDiagnosticData({
                ...diagnosticData,
                "39": diagnosticData.correo_electronico || email || "",
                "26": diagnosticData.edad || (age ? age.toString() : ""),
                "34":
                    diagnosticData.nombre_apellidos ||
                    (firstName || "") + " " + (lastName || ""),
                // "21": diagnosticData.municipio || (city || ""),
                // "35":
                //     diagnosticData.tipo_documento ||
                //     (docTypes ? docTypes[docType.charAt(docType.length - 1)] : ""),
                "36": diagnosticData.numero_documento || docNumber || "",
                "38":
                    diagnosticData.numero_telefono_celular || mobile || "",
                "37": diagnosticData.numero_telefono_fijo || phone || "",
                // "20": diagnosticData.genero || (gender ? genders[gender] : ""),
            });
            setDiagnosticDataV2([
                ...diagnosticDataV2,
                //    { idQuestion: "20", idOption: null, openResponse: gender ? genders[gender] : "" },
                //    { idQuestion: "21", idOption: null, openResponse: city || "" },
                { idQuestion: "26", idOption: null, openResponse: age ? age.toString() : "" },
                {
                    idQuestion: "34",
                    idOption: null,
                    openResponse: (firstName || "") + " " + (lastName || ""),
                },
                //    {
                //       idQuestion: "35",
                //       idOption: null,
                //       openResponse: (docTypes ? docTypes[docType.charAt(docType.length - 1)] : ""),
                //    },
                { idQuestion: "36", idOption: null, openResponse: docNumber || "" },
                { idQuestion: "37", idOption: null, openResponse: phone || "" },
                { idQuestion: "38", idOption: null, openResponse: mobile || "" },
                {
                    idQuestion: "39",
                    idOption: null,
                    openResponse: email || "",
                },
                // dummie preguntas calculadas
                //    {
                //     "idOption": null,
                //     "idQuestion": 157,
                //     "openResponse": "1000000"
                //   },
                //   {
                //     "idOption": null,
                //     "idQuestion": 158,
                //     "openResponse": "1000000"
                //   },
                //   {
                //     "idOption": null,
                //     "idQuestion": 159,
                //     "openResponse": "400000"
                //   },
                //   {
                //     "idOption": null,
                //     "idQuestion": 160,
                //     "openResponse": "30000"
                //   },
                //   {
                //     "idOption": null,
                //     "idQuestion": 161,
                //     "openResponse": "700000"
                //   }
            ]);
        }
    }, [Context.gigyaContext.gigyaAccount]);

    const handleContinueRoute = () => {
        //Logica para mostrar CAC
        setCac(true);

        // setContinueRoute(true);
    }

    const setDataV2 = (value, field, type: any = null) => {
        let dummie = {
            idQuestion: field,
            idOption: null,
            openResponse: "",
        };
        let questionPos = diagnosticDataV2.findIndex(
            (item) => item.idQuestion === field
        );
        let parsedValue;
        try {
            parsedValue = JSON.parse(value);
        } catch (error) {
            parsedValue = value;
        }
        if (parsedValue?.id) {
            dummie.idOption = parsedValue.id;
            dummie.openResponse = parsedValue.name;
        } else {
            dummie.openResponse = value;
        }
        let processed = [...diagnosticDataV2];
        if (type === "checkbox") {
            let exist = processed.findIndex(
                (question) =>
                    question.idQuestion === field &&
                    question.idOption === parsedValue.id
            );
            if (exist != -1) {
                // se filtra elemento por si ya existe
                processed.splice(exist, 1);
            } else {
                if (questionPos !== -1) {
                    processed.splice(questionPos, 0, dummie)
                } else {
                    processed.push(dummie);
                }
            }
        } else {
            if (questionPos !== -1) {
                processed[questionPos] = dummie;
            } else {
                processed.push(dummie);
            }
        }

        setDiagnosticDataV2(processed);
    };

    const setData = (value, field, type: any = null) => {

        setDataV2(value, field, type);

        let parsedValue;

        try {
            parsedValue = JSON.parse(value);
        } catch (error) {
            parsedValue = value;
        }

        const newFormData = { ...diagnosticData };
        if (!type) {
            newFormData[field] = parsedValue;
        } else if (type === "checkbox") {

            if (newFormData[field] === undefined) {
                newFormData[field] = [parsedValue];
            } else {
                const index = newFormData[field].findIndex((el) => el.id === parsedValue.id)
                if (index >= 0) {
                    newFormData[field].splice(index, 1);
                } else newFormData[field] = [...newFormData[field], parsedValue];
            }
        }
        setDiagnosticData(newFormData);
    }

    const handleContinueResults = async () => {
        setLoading(true);
        saveResponses().then(async (res) => {
            if (res?.data.status === 200) {
                try {
                    let token;
                    if (Context.gigyaContext.gigyaAccount) {
                        token = await getToken(Context.gigyaContext.gigyaAccount.UID);
                    } else {
                        return;
                    }
                    const response = await getResults(token.id_token);

                    setResult(response.data.data);
                    setLoading(false);
                    setShowResults(true);

                } catch (error) {
                    console.error(error);
                    setLoading(false);
                }
            } else {
                alert('el diagnóstico NO se guardó');
            }
        }).catch(err => {
            console.error(err)
            alert('¡Ups!, Hubo un error en el servidor o de conexión.')
        })
        // setLoading(false);       
    }

    const saveResponses = async () => {
        try {
            let token;
            if (Context.gigyaContext.gigyaAccount) {
                token = await getToken(Context.gigyaContext.gigyaAccount.UID);
            } else {
                return;
            }
            return postResponsesDiagnostic(token.id_token, diagnosticDataV2);

        } catch (error) {
            console.error(error);
        }
    }

    const handleContinueClick = async () => {
        setLoading(true);
        try {
            let token;
            if (Context.gigyaContext.gigyaAccount) {
                token = await getToken(Context.gigyaContext.gigyaAccount.UID);
            } else {
                return;
            }
            const response = await getDiagnosticQuestions(token.id_token);

            const questions: any = []
            const tempHeaders: any = [];

            // response?.data?.data.forEach((purpose: any) => {
            //     questions = [...questions, ...purpose.questions]
            // });
            response?.data?.data.forEach((purpose: any) => {
                questions.push(...purpose.questions);
                tempHeaders.push({ title: purpose.name, value: purpose.id });
            });
            // diagnostic_data?.data.forEach((purpose: any) => {
            //     questions.push(...purpose.questions);
            //     tempHeaders.push({ title: purpose.name, value: purpose.id });
            // });
            setHeaders(tempHeaders);
            setStep(tempHeaders[0].value);
            setDiagnosticQuestions(questions);
            setShowQuestions(true);
            setLoading(false);

        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }

    return (
        <div className="o-mentoriaDiagnostico-container">
            {/* <button onClick={handleContinueResults}>jeje</button> */}
            {showResults ?
                <MentoriaResultados
                    propositosImages={props.headerImages}
                    faces={props.facesIcons}
                    toolTip={props.tooltipImage}
                    results={result}
                    agendamientoIcons={props.agendamientoIcons}
                    rutaPhotos={props.rutaPhotos}
                />
                :
                !showQuestions ?
                    <>
                        <h2 className='o-mentoriaDiagnostico-container__title'>Diagnóstico</h2>
                        <section className="o-mentoriaDiagnostico-container__description">
                            <h3 className="o-mentoriaDiagnostico-container__description__title">¿Conoces el estado de tus finanzas?</h3>
                            <p className="o-mentoriaDiagnostico-container__description__subtitle">En Comfama queremos ayudarte para que mejores el manejo de tu dinero, de forma que puedas organizar y alcanzar tus propósitos</p>
                            {loading &&
                                <div className="mentoria-propositos__loading">
                                    <Loading />
                                </div>
                            }
                            <SubsectionContainer {...props.estadoFinanzasData} />
                            <Button
                                type={"button"}
                                text="Comenzar"
                                gtmMark='secondary'
                                classname='o-mentoriaDiagnostico-container__description__button'
                                isDisabled={false}
                                onClickAction={handleContinueClick}
                            />
                        </section>
                    </> :
                    diagnosticQuestions && <>
                        <Stepper
                            steps={headers}
                            currentStep={step}
                        />
                        {acceptTratamiento ?
                            <MentoriaQuestionWizard
                                questions={diagnosticQuestions}
                                formData={diagnosticData}
                                blobImage={props.blobImage}
                                setData={setData}
                                onMoveAfterFallback={handleContinueResults}
                                onMovePreviousFallback={() => { }}
                                setHeaderStep={setStep}
                            />
                            :
                            <TratamientoDatos blobImage={props.blobImage} setAcceptTratamiento={setAcceptTratamiento} otpIcons={props.otpIcons} />
                        }
                    </>
            }
        </div>
        // <MentoriaAgendamientoCitas icons={props.agendamientoIcons}></MentoriaAgendamientoCitas>
        // <MentoriaOtp otpIcons={props.otpIcons} />
    )
}

export default MentoriaDiagnostico